/* Light Armor — Bold Options skin (added 2026-08-22, rev 2026-08-22b)
 * Renders grouped, labelled option cards in front of the Bold Options widget.
 * Bold's real inputs stay in the DOM (moved off-screen by CSS); every card click
 * is forwarded to the matching Bold input, so Bold keeps owning price math,
 * conditional logic and the cart handoff. If Bold never renders, the skin
 * never activates and the stock form (plus the Bold guard) shows as before.
 *
 * rev b: Bold fires ~13 DOM mutations after every selection. The first version
 * rebuilt all cards on each of those, which made the options flicker and could
 * drop a click that landed mid-rebuild. Now we fingerprint the option set and
 * only rebuild when it actually changes; otherwise we just re-sync selected
 * state. Inputs are also re-resolved from the live DOM at click time.
 */
(function () {
  'use strict';
  if (window.__laBuySkinInit) return;
  window.__laBuySkinInit = true;

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function lower(s) { return norm(s).toLowerCase(); }
  function money(n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function parsePrice(s) { var m = /\$\s?([\d,]+(?:\.\d+)?)/.exec(s || ''); return m ? parseFloat(m[1].replace(/,/g, '')) : 0; }
  function stripPrice(s) { return norm(s).replace(/\s*\[\+?\$[\d,.]+\]\s*/g, '').replace(/\s*\+?\$[\d,.]+\s*$/g, '').trim(); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
  function lookup(map, label) {
    var l = lower(label);
    if (map[l] !== undefined) return map[l];
    var best = null;
    Object.keys(map).forEach(function (k) { if (l.indexOf(k) === 0 && (!best || k.length > best.length)) best = k; });
    return best ? map[best] : undefined;
  }
  /* Title-case a Bold label, but leave connector words alone so we never fight the
     wording set in the app (e.g. "Blower Fan and Vented System" stays lowercase "and"). */
  var SMALLWORDS = /^(a|an|and|as|at|by|for|from|in|of|on|or|per|the|to|with|vs)$/;
  function titleCase(s) {
    var words = norm(s).split(' ');
    return words.map(function (w, i) {
      if (i > 0 && SMALLWORDS.test(w.toLowerCase())) return w.toLowerCase();
      return w.replace(/^([a-z])/, function (m, c) { return c.toUpperCase(); });
    }).join(' ');
  }
  /* Titles run "LA2500B Powder Coat Oven (2' x 2' x 5')", "LA Mini Benchtop Oven (…)",
     "LABS-486 …" and "In-Stock and Loaded LA10K7 Oven (…)". Take the model token,
     keeping the second word when the first is just "LA". */
  function modelName(title) {
    var t = String(title || '').replace(/^in-stock(\s+and\s+loaded)?\s+/i, '').trim();
    var w = t.split(/\s+/);
    var m = w[0] || '';
    if (/^LA$/i.test(m) && w[1]) m = m + ' ' + w[1];
    return /^LA/.test(m) ? m : '';
  }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  /* ---------- option wording ----------
     The COPY/SHORT/HEADS/TIPS dictionaries used to live here and were about a fifth of this
     file. They are the part that actually gets edited — a label reworded, a new explainer —
     so they now sit in assets/la-skin-copy.js and a wording change is a small push instead
     of the whole skin.

     Two ways it arrives. On a product page snippets/la-buy-top.liquid loads it with a plain
     tag, so it is already in place before this deferred file runs. The cart page renders no
     such snippet, so we pull it in ourselves below, deriving the URL from our own src rather
     than hardcoding a CDN path.

     dict() reads window.__laSkinCopy at call time, never at load time. That is what makes the
     cart's injected fetch safe: if someone opens Bold's Edit Order lightbox in the moment
     before it lands, those first lookups fall back to Bold's own labels and every lookup
     after it arrives is correct — no race, no throw, no wrong-looking cached copy. */
  function dict(name) { var c = window.__laSkinCopy; return (c && c[name]) || {}; }

  if (!window.__laSkinCopy && !window.__laSkinCopyLoading) {
    window.__laSkinCopyLoading = true;
    var me = document.currentScript || (function () {
      var all = document.querySelectorAll('script[src*="la-buy-skin"]');
      return all[all.length - 1] || null;
    }());
    if (me && me.src) {
      var s = document.createElement('script');
      s.src = me.src.replace(/la-buy-skin\.js/, 'la-skin-copy.js');
      s.async = true;
      document.head.appendChild(s);
    }
  }



  /* Shared option-label dictionaries live above; everything below is per-mount state. */
  function createSkin(cfg) {
  var BASE_PRICE = cfg.basePrice || 0, NOUN = cfg.noun || 'Oven', PTITLE = cfg.productTitle || '';
  var host = cfg.host, promoHost = cfg.promoHost || null, form = cfg.form, totalBox = cfg.totalBox || null, wrapEl = cfg.wrapEl || host.closest('.la-buy');
  var bold = null;
  var models = [], lastSig = '', building = false, syncing = false, quietUntil = 0;


  var LEAD = /turnaround|lead time|expedite/i;
  var GROUPS = [
    { key: 'build', match: /element|insulation|blower|fan|base|window|peep|electrical|wiring|controller|door|rack|shelf|color|thermocouple|phase|light|odor|filter/i },
    { key: 'ship', match: /freight|crate|warranty|turnaround|expedite|pickup|lead time/i }
  ];

  /* ---------- read Bold's DOM into a model ---------- */
  function readOptions() {
    var out = [];
    bold.querySelectorAll('.bold_option').forEach(function (opt) {
      var titleEl = opt.querySelector('.bold_option_title');
      var rawTitle = norm(titleEl ? titleEl.textContent : '');
      var required = /\*$/.test(rawTitle);
      var title = rawTitle.replace(/\*$/, '').trim();
      var headFix = lookup(dict('HEADS'), title);
      if (headFix) title = headFix;
      var tip = opt.querySelector('.bold_tooltip');
      var model = { el: opt, title: title, required: required, tip: tip ? norm(tip.textContent) : '', values: [], type: '' };
      var sel = opt.querySelector('select');
      if (sel) {
        model.type = 'select';
        model.input = sel;
        Array.prototype.forEach.call(sel.options, function (o, i) {
          if (!o.value) return;
          model.values.push({ value: o.value, label: stripPrice(o.textContent), price: parsePrice(o.textContent), index: i, disabled: o.disabled });
        });
      } else if (opt.classList.contains('bold_option_checkbox') && opt.querySelectorAll('input[type=checkbox]').length === 1 && !opt.querySelector('.bold_option_value')) {
        model.type = 'single';
        model.input = opt.querySelector('input[type=checkbox]');
      } else {
        model.type = 'cards';
        opt.querySelectorAll('.bold_option_value').forEach(function (v) {
          var inp = v.querySelector('input[type=checkbox],input[type=radio]');
          if (!inp) return;
          var t = v.querySelector('.bold_option_value_title');
          var p = v.querySelector('.bold_option_value_price');
          var swatch = v.querySelector('.bold_option_value_swatch span, .bold_option_value_swatch img');
          var img = '';
          if (swatch) {
            if (swatch.tagName === 'IMG') img = swatch.getAttribute('src');
            else { var m = /url\(["']?(.*?)["']?\)/.exec(getComputedStyle(swatch).backgroundImage); if (m) img = m[1]; }
          }
          model.values.push({
            value: inp.value, label: stripPrice(t ? t.textContent : inp.value),
            price: parsePrice(p ? p.textContent : ''), input: inp, img: img,
            disabled: inp.disabled || v.classList.contains('bold_option_out_of_stock')
          });
        });
        if (!model.values.length) return;
      }
      out.push(model);
    });
    return out;
  }

  /* Fingerprint of the option STRUCTURE (not the current selection). Bold
     re-renders itself constantly; we only tear our cards down when this moves. */
  function signature(opts) {
    return opts.map(function (o) {
      return o.title + '|' + o.type + '|' + o.values.map(function (v) { return v.value + ':' + v.price + ':' + (v.disabled ? 1 : 0); }).join(',');
    }).join('~');
  }

  /* Bold's own nodes can be swapped out; always act on what is in the DOM now. */
  function liveInput(o, v) {
    if (v.input && document.contains(v.input)) return v.input;
    var root = document.contains(o.el) ? o.el : null;
    if (!root) return null;
    var found = null;
    root.querySelectorAll('input[type=checkbox],input[type=radio]').forEach(function (i) { if (!found && i.value === v.value) found = i; });
    if (found) v.input = found;
    return found;
  }
  function liveSelect(o) {
    if (o.input && document.contains(o.input)) return o.input;
    var s = document.contains(o.el) ? o.el.querySelector('select') : null;
    if (s) o.input = s;
    return s;
  }

  /* ---------- render ---------- */
  function build(opts) {
    if (building) return; building = true;
    try {
      var openState = {};
      host.querySelectorAll('details').forEach(function (d) { openState[d.dataset.group] = d.open; });
      host.innerHTML = '';
      if (promoHost) promoHost.innerHTML = '';
      models = opts;

      var groups = GROUPS.map(function (g) { return { def: g, opts: [] }; });
      var singles = [];
      opts.forEach(function (o) {
        if (o.type === 'single') { singles.push(o); return; }
        var g = groups.find(function (gg) { return gg.def.match.test(o.title); }) || groups[0];
        g.opts.push(o);
      });

      var n = 0;
      groups.forEach(function (g) {
        if (!g.opts.length) return;
        n++;
        var title = g.def.key === 'build'
          ? 'Build Your ' + NOUN
          : (g.opts.some(function (o) { return LEAD.test(o.title); }) ? 'Lead Time &amp; Protection' : 'Delivery &amp; Protection');
        var d = el('details', 'la-grp'); d.dataset.group = g.def.key;
        d.open = openState[g.def.key] !== undefined ? openState[g.def.key] : n === 1;
        d.appendChild(el('summary', '', '<span class="la-grp__n">' + n + '</span><span class="la-grp__t">' + title +
          '</span>' + (d.open ? '' : '<span class="la-grp__pill">Review</span>') +
          '<span class="la-grp__s" data-summary></span><span class="la-grp__chev" aria-hidden="true"></span>'));
        if (!d.open) {
          d.classList.add('la-grp--nudge');
          d.addEventListener('toggle', function () {
            if (!d.open) return;
            d.classList.remove('la-grp--nudge');
            var pill = d.querySelector('.la-grp__pill');
            if (pill) pill.remove();
          });
        }
        var body = el('div', 'la-grp__body');
        g.opts.forEach(function (o) { body.appendChild(renderOption(o)); });
        d.appendChild(body);
        host.appendChild(d);
      });
      singles.forEach(function (o) { (promoHost || host).appendChild(renderSingle(o)); });
      /* Don't add the standalone note when the promo is already showing as a checkbox
         (Bold still has it flagged required) — that would print the offer twice. */
      if (cfg.alwaysPromo && promoHost && !promoHost.querySelector('.la-promo-note')
          && !promoHost.querySelector('.la-single')) {
        promoHost.appendChild(promoNote());
      }
      satisfyPhantoms();
      setTimeout(satisfyPhantoms, 800);
      applyRecommended();
      setTimeout(applyRecommended, 1200);
      if (wrapEl) wrapEl.classList.add('la-skin-on');
      sync();
    } finally { building = false; }
  }

  /* Resolve the plain-language explainer for an option heading, if we have one.
     A few are per-product functions (fan placement differs by model). */
  function tipFor(o) {
    var t = lookup(dict('TIPS'), o.title);
    return typeof t === 'function' ? t(PTITLE) : t;
  }

  /* The (i) button and its collapsible box, built together but returned apart: the
     button belongs inside a heading, the box goes after it. */
  function tipParts(o, text) {
    var btn = el('button', 'la-i');
    btn.type = 'button'; btn.textContent = 'i';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'More about ' + o.title);
    var box = el('div', 'la-opt__tip');
    box.textContent = text; box.hidden = true;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      box.hidden = !box.hidden;
      btn.setAttribute('aria-expanded', String(!box.hidden));
    });
    return { btn: btn, box: box };
  }

  /* Pre-built (in-stock) units render their installed upgrades as locked rows. Someone
     who lands on an in-stock page first never sees the configurator, so these rows were
     a line item and a price with nothing explaining what the money bought. Give them the
     same (i) explainer the build-to-order options carry. */
  function renderLocked(o) {
    var v = o.values[0];
    var wrap = el('div', 'la-opt la-opt--locked');
    wrap.innerHTML = '<div class="la-lock"><span class="la-lock__ic" aria-hidden="true">&#128274;</span>' +
      '<span class="la-lock__t"><b>' + esc(o.title) + '</b>' + esc(lookup(dict('SHORT'), v.label) || titleCase(v.label)) + '</span>' +
      '<i>' + (v.price ? '+' + money(v.price) : 'Included') + '</i></div>';
    var text = tipFor(o);
    if (text) {
      var p = tipParts(o, text);
      wrap.querySelector('.la-lock__t b').appendChild(p.btn);
      wrap.appendChild(p.box);
    }
    wrap.__model = o;
    return wrap;
  }

  /* Options that are really a count (No / One / Two ... Eight blower fans) waste a
     huge amount of column height as image cards, and every card shows the same photo.
     Detect them and render a compact pill row plus one caption for the choice made. */
  var NUMWORD = { no: 0, none: 0, zero: 0, single: 1, one: 1, double: 2, two: 2, triple: 3, three: 3,
                  four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10 };
  function scaleInfo(o) {
    if (o.type !== 'cards' || o.values.length < 5) return null;
    var nums = [], seen = {}, unknown = -1;
    for (var i = 0; i < o.values.length; i++) {
      var first = lower(o.values[i].label).split(/[\s(]+/)[0].replace(/[^a-z0-9]/g, '');
      var n = NUMWORD[first];
      if (n === undefined && /^\d+$/.test(first)) n = parseInt(first, 10);
      if (n === undefined) {
        /* Bold writes the singular as "Blower Fan", not "One Blower Fan". Tolerate one
           unlabelled value and infer it from the gap in the sequence. */
        if (unknown !== -1) return null;
        unknown = i; nums.push(null); continue;
      }
      if (seen[n]) return null;
      seen[n] = 1; nums.push(n);
    }
    if (unknown !== -1) {
      var known = nums.filter(function (x) { return x !== null; });
      var lo = Math.min.apply(null, known), hi = Math.max.apply(null, known), miss = [];
      for (var k = lo; k <= hi; k++) { if (!seen[k]) miss.push(k); }
      if (miss.length !== 1) return null;
      nums[unknown] = miss[0];
    }
    for (var j = 1; j < nums.length; j++) { if (nums[j] <= nums[j - 1]) return null; }
    return nums;
  }

  /* Turnaround wording varies per product (5-10, 10~15, "or less"). Read the figure out
     of Bold's own label instead of mapping it, so the card can never state a stale range. */
  function leadCopy(label) {
    var r = /(\d+)\s*[-~–—]\s*(\d+)\s*business days/i.exec(label);
    if (r) return r[1] + '–' + r[2] + ' business days';
    var s1 = /(\d+)\s*business days or less/i.exec(label);
    if (s1) return s1[1] + ' business days or less';
    return undefined;
  }

  function optHead(o) {
    var frag = document.createDocumentFragment();
    var text = tipFor(o);
    /* Where we supply our own explainer, drop Bold's inline note — the (i) covers it. */
    var head = el('div', 'la-opt__label', '<span>' + esc(o.title) + '</span>' + ((o.tip && !text) ? '<em> — ' + esc(o.tip) + '</em>' : ''));
    frag.appendChild(head);
    if (text) {
      var p = tipParts(o, text);
      head.appendChild(p.btn);
      frag.appendChild(p.box);
    }
    return frag;
  }

  function renderScale(o, nums) {
    var wrap = el('div', 'la-opt la-opt--scale');
    wrap.appendChild(optHead(o));
    var row = el('div', 'la-scale');
    o.values.forEach(function (v, i) {
      var b = el('button', 'la-scale__p' + (v.disabled ? ' is-disabled' : ''));
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.title = v.label + (v.price ? ' (+' + money(v.price) + ')' : '');
      b.textContent = nums[i] === 0 ? 'None' : String(nums[i]);
      b.addEventListener('click', function (e) { e.preventDefault(); if (!v.disabled) select(o, v); });
      v.card = b;
      row.appendChild(b);
    });
    wrap.appendChild(row);
    var cap = el('div', 'la-scale__cap');
    wrap.appendChild(cap);
    o.cap = cap;
    o.nums = nums;
    wrap.__model = o;
    return wrap;
  }

  /* The spec table already states e.g. "Recommended # of Blower Fans  3-4".
     Read it from the page rather than duplicating the number in a metafield. */
  function recommendedFans() {
    var rows = document.querySelectorAll('tr');
    for (var i = 0; i < rows.length; i++) {
      if (!/recommended\s*#?\s*of\s*blower\s*fans?/i.test(rows[i].textContent)) continue;
      var cells = rows[i].children;
      var val = cells.length > 1 ? cells[cells.length - 1].textContent : rows[i].textContent;
      var nums = (val.match(/\d+/g) || []).map(Number);
      if (!nums.length) continue;
      var out = {}, lo = Math.min.apply(null, nums), hi = Math.max.apply(null, nums);
      if (hi - lo > 8) return null;
      for (var n = lo; n <= hi; n++) out[n] = 1;
      return out;
    }
    return null;
  }

  function applyRecommended() {
    var recs = recommendedFans();
    if (!recs) return;
    var keys = Object.keys(recs).map(Number).sort(function (a, b) { return a - b; });
    var txt = keys.length > 1 ? keys[0] + '–' + keys[keys.length - 1] : String(keys[0]);
    host.querySelectorAll('.la-opt--scale').forEach(function (w) {
      var o = w.__model;
      if (!o || !o.nums || !/blower|fan/i.test(o.title)) return;
      var any = false;
      o.values.forEach(function (v, i) {
        if (v.card && recs[o.nums[i]]) { v.card.classList.add('is-rec'); any = true; }
      });
      if (any && !w.querySelector('.la-scale__rec')) {
        var hint = el('div', 'la-scale__rec',
          '<span class="la-scale__dot" aria-hidden="true"></span>We recommend <b>' + txt + '</b> for this model');
        var row = w.querySelector('.la-scale');
        if (row) row.insertAdjacentElement('afterend', hint);
      }
    });
  }

  function renderOption(o) {
    if (o.values.length === 1) return renderLocked(o);
    var sc = scaleInfo(o);
    if (sc) return renderScale(o, sc);
    var wrap = el('div', 'la-opt');
    wrap.appendChild(optHead(o));
    var n = o.values.length;
    var cols = n <= 4 ? n : n <= 6 ? 3 : 4;
    var hasImg = o.values.some(function (v) { return v.img; });
    var grid = el('div', 'la-cards la-cards--c' + cols + (hasImg ? '' : ' la-cards--text') + (cols >= 4 ? ' la-cards--dense' : ''));
    o.values.forEach(function (v) {
      var shortHit = lookup(dict('SHORT'), v.label);
      var short = shortHit || titleCase(v.label);
      var copy = leadCopy(v.label);
      if (copy === undefined) copy = lookup(dict('COPY'), v.label);
      /* Only fall back to Bold's full string when we actually shortened the title —
         otherwise the grey line just repeats what is already in bold above it. */
      if (copy === undefined && shortHit && shortHit !== v.label) copy = v.label;
      var c = el('button', 'la-card' + (v.disabled ? ' is-disabled' : ''));
      c.type = 'button';
      c.setAttribute('role', 'radio');
      c.innerHTML = (v.img ? '<span class="la-card__img" style="background-image:url(' + v.img + ')"></span>' : '') +
        '<b>' + esc(short) + '</b>' + (copy ? '<small>' + esc(copy) + '</small>' : '') +
        '<i>' + (v.price ? '+' + money(v.price) : 'Included') + '</i>';
      c.addEventListener('click', function (e) { e.preventDefault(); if (!v.disabled) select(o, v); });
      v.card = c;
      grid.appendChild(c);
    });
    wrap.appendChild(grid);
    wrap.__model = o;
    return wrap;
  }

  /* The Bold "I'm aware of the Feedback Promo" acknowledgement, restyled as a
     promo bar and moved below Add to Cart. Bold marks it required, so it stays
     a real checkbox wired to Bold's own input. */
  function promoNote() {
    return el('div', 'la-promo-note',
      '<span aria-hidden="true">💰</span> Earn up to $500 back with the <b>Feedback Promo</b>. ' +
      '<a href="/pages/discounts-promos" target="_blank" rel="noopener">How it works</a>');
  }

  function renderSingle(o) {
    var isPromo = /feedback promo/i.test(o.title);
    /* Always a plain note. Bold's own API no longer returns this option — it was deleted in
       the app — yet Bold's widget still renders it here from a stale cache and still marks it
       required. It is handled by satisfyPhantoms() below rather than by a checkbox. */
    if (isPromo) { if (o.required) o.phantom = true; return promoNote(); }
    var row = el('label', 'la-single');
    var cb = el('input'); cb.type = 'checkbox';
    cb.checked = !!(o.input && o.input.checked);
    cb.addEventListener('change', function () {
      var live = liveSingle(o);
      if (live && live.checked !== cb.checked) live.click();
      quiet(); setTimeout(sync, 60);
    });
    row.appendChild(cb);
    row.appendChild(el('span', 'la-single__t', isPromo
      ? '<b>Earn up to $500 back with the Feedback Promo</b><small>Tick to take part — full details on the <a href="/pages/discounts-promos" target="_blank" rel="noopener">Discounts &amp; Promos page</a>.</small>'
      : '<b>' + esc(o.title) + '</b>' + (o.tip ? '<small>' + esc(o.tip) + '</small>' : '')));
    o.mirror = cb;
    return row;
  }
  function liveSingle(o) {
    if (o.input && document.contains(o.input)) return o.input;
    var i = document.contains(o.el) ? o.el.querySelector('input[type=checkbox]') : null;
    if (i) o.input = i;
    return i;
  }

  /* ---------- forward to Bold ---------- */
  function quiet() { quietUntil = Date.now() + 900; }

  function paintChoice(o, v) {
    o.values.forEach(function (x) { if (x.card) { var on = x === v; x.card.classList.toggle('is-selected', on); x.card.setAttribute('aria-checked', on); } });
    o.optimistic = v;
  }

  function select(o, v) {
    quiet();
    paintChoice(o, v);            /* instant feedback; sync() reconciles with Bold below */
    sync(true);
    if (o.type === 'select') {
      var s = liveSelect(o);
      if (s && s.selectedIndex !== v.index) { s.selectedIndex = v.index; s.dispatchEvent(new Event('change', { bubbles: true })); }
    } else {
      var inp = liveInput(o, v);
      if (inp && !inp.checked) inp.click();
    }
    sync();
    setTimeout(sync, 120);
    setTimeout(sync, 500);
  }

  /* Pre-built (in-stock) units: an option with a single value is part of the
     unit. Keep Bold's input for it selected no matter what, and re-assert on
     submit so a unit can never be carted with a built-in upgrade missing. */
  function assertLocked(o) {
    var v = o.values[0];
    if (o.type === 'select') {
      var s = liveSelect(o);
      if (s && s.selectedIndex !== v.index) { s.selectedIndex = v.index; s.dispatchEvent(new Event('change', { bubbles: true })); }
    } else {
      var inp = liveInput(o, v);
      if (inp && !inp.checked) inp.click();
    }
  }
  function assertAllLocked() {
    models.forEach(function (o) { if (o.type !== 'single' && o.values.length === 1) assertLocked(o); });
  }

  /* ---------- read Bold state back ---------- */
  function sync(optimistic) {
    if (syncing || !models.length) return; syncing = true;
    try {
      var count = 0, ourExtras = 0;
      host.querySelectorAll('.la-grp').forEach(function (d) {
        var gExtras = 0, gCount = 0, picks = [], allPicks = [];
        d.querySelectorAll('.la-opt').forEach(function (w) {
          var o = w.__model; if (!o) return;
          var chosen = null;
          if (o.values.length === 1) {
            assertLocked(o); chosen = o.values[0];
          } else if (optimistic && o.optimistic) {
            chosen = o.optimistic;        /* just clicked: trust our own paint for this pass */
          } else if (o.type === 'select') {
            var s = liveSelect(o), idx = s ? s.selectedIndex : -1;
            o.values.forEach(function (v) {
              var on = v.index === idx;
              if (v.card) { v.card.classList.toggle('is-selected', on); v.card.setAttribute('aria-checked', on); }
              if (on) chosen = v;
            });
            o.optimistic = null;
          } else {
            o.values.forEach(function (v) {
              var inp = liveInput(o, v), on = !!(inp && inp.checked);
              if (v.card) { v.card.classList.toggle('is-selected', on); v.card.setAttribute('aria-checked', on); }
              if (on) chosen = v;
            });
            o.optimistic = null;
          }
          if (o.cap && chosen) {
            var cShort = lookup(dict('SHORT'), chosen.label) || titleCase(chosen.label);
            var cCopy = lookup(dict('COPY'), chosen.label);
            o.cap.innerHTML = (chosen.img ? '<span class="la-scale__im" style="background-image:url(' + chosen.img + ')"></span>' : '') +
              '<span class="la-scale__t"><b>' + esc(cShort) + '</b>' + (cCopy ? '<small>' + esc(cCopy) + '</small>' : '') + '</span>' +
              '<i>' + (chosen.price ? '+' + money(chosen.price) : 'Included') + '</i>';
          }
          if (chosen) allPicks.push(lookup(dict('SHORT'), chosen.label) || titleCase(chosen.label));
          if (chosen && chosen.price) { gExtras += chosen.price; gCount++; picks.push(lookup(dict('SHORT'), chosen.label) || titleCase(chosen.label)); }
          if (chosen) ourExtras += chosen.price || 0;
        });
        var s2 = d.querySelector('[data-summary]');
        if (s2) {
          if (gCount) {
            s2.textContent = picks.length > 2
              ? gCount + ' upgrades · +' + money(gExtras)
              : picks.join(' · ') + ' · +' + money(gExtras);
          } else if (d.dataset.group === 'ship') {
            /* Nobody opens a collapsed panel, so say what they get by default —
               a shopper who wants a crate or a rush needs to see it isn't set. */
            s2.textContent = allPicks.slice(0, 3).join(' · ');
          } else {
            s2.textContent = 'Standard · +$0';
          }
        }
        count += gCount;
      });
      models.forEach(function (o) {
        if (o.type === 'single' && o.mirror) { var i = liveSingle(o); if (i) o.mirror.checked = i.checked; }
      });
      /* Bold's own total is the source of truth for money, but right after a
         click it lags ~1s — show our own sum until Bold catches up. */
      var bt = bold.querySelector('.bold_option_total span');
      var boldExtras = bt ? parsePrice(bt.textContent) : 0;
      var extras = (optimistic || Date.now() < quietUntil) ? ourExtras : boldExtras;
      if (totalBox) {
        totalBox.querySelector('[data-la-extras]').textContent = '+' + money(extras);
        totalBox.querySelector('[data-la-count]').textContent = count;
        totalBox.querySelector('[data-la-total]').textContent = money(BASE_PRICE + extras);
      }
    } finally { syncing = false; }
  }


  var baseLbl = totalBox && totalBox.querySelector('.la-total__r span');
  if (baseLbl) {
    var mn0 = modelName(PTITLE);
    baseLbl.textContent = mn0 ? mn0 + ' Base' : 'Base price';
  }

  var timer = null;
  function refresh() {
    bold = cfg.getBold();
    if (!bold || !bold.querySelector('.bold_option')) return;
    var opts = readOptions();
    if (!opts.length) return;
    var sig = signature(opts);
    var stale = models.length && models.some(function (o) { return !document.contains(o.el); });
    if (sig === lastSig && !stale) { sync(); return; }   /* structure unchanged: no teardown, no flicker */
    lastSig = sig;
    build(opts);
  }
  function schedule(delay) { clearTimeout(timer); timer = setTimeout(refresh, delay || 60); }

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (host.contains(muts[i].target) || (promoHost && promoHost.contains(muts[i].target))) continue;
      if (Date.now() < quietUntil) { sync(); return; }
      schedule();
      return;
    }
  });
  mo.observe(form, { childList: true, subtree: true });
  form.addEventListener('change', function (e) { if (!host.contains(e.target)) setTimeout(sync, 30); });
  /* A required Bold option we deliberately don't draw a control for (currently only the
     Feedback Promo, which Shop Circle still serves from a stale cache after it was deleted
     in the app) would otherwise block add-to-cart with an error nobody can act on. Tick
     Bold's own input so its validator passes, then drop the option from the submitted form
     so the order never records an acknowledgement the shopper didn't actually give — the
     offer itself stays on the page as the visible promo note. */
  function phantomOpts() {
    return models.filter(function (o) { return o.phantom; });
  }
  function satisfyPhantoms() {
    phantomOpts().forEach(function (o) {
      var i = liveSingle(o);
      if (i && !i.checked) { quiet(); i.click(); }
    });
  }
  form.addEventListener('submit', function () {
    phantomOpts().forEach(function (o) {
      if (!document.contains(o.el)) return;
      o.el.querySelectorAll('input,select,textarea').forEach(function (i) { i.disabled = true; });
    });
  }, true);

  form.addEventListener('submit', assertAllLocked, true);

  /* Bold validates on submit and writes .bold_error_message inside its own markup, which
     this skin parks off-screen. Mirror any such message into the visible column. */
  function showBoldErrors() {
    /* The box is inserted next to Add to Cart, which is outside `host` — look it up on the
       form, or a second call creates a duplicate instead of updating the first. */
    var box = form.querySelector('[data-la-err]');
    var msgs = [];
    form.querySelectorAll('.bold_error_message').forEach(function (e) {
      var opt = e.closest('.bold_option');
      var t = opt ? opt.querySelector('.bold_option_title') : null;
      var head = t ? norm(t.textContent).replace(/\*$/, '').trim() : '';
      head = lookup(dict('HEADS'), head) || head;
      var text = norm(e.textContent);
      if (text) msgs.push(head ? head + ': ' + text : text);
    });
    if (!msgs.length) { if (box) box.remove(); return; }
    if (!box) {
      box = el('div', 'la-err');
      box.setAttribute('data-la-err', '');
      box.setAttribute('role', 'alert');
      var anchor = form.querySelector('.product-info__add-to-cart');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor);
      else host.appendChild(box);
    }
    box.innerHTML = '<b>Please finish choosing your options</b><ul><li>' +
      msgs.map(esc).join('</li><li>') + '</li></ul>';
    box.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  if (cfg.submitSelector) document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest(cfg.submitSelector)) {
      setTimeout(showBoldErrors, 250);
      setTimeout(showBoldErrors, 900);
    }
  }, true);
  if (cfg.submitSelector) document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest(cfg.submitSelector)) assertAllLocked();
  }, true);
  schedule(0);
  return { refresh: refresh, sync: sync, destroy: function () { mo.disconnect(); clearTimeout(timer); } };
  }

  /* ---------- product page ---------- */
  function initProduct() {
    var host = document.querySelector('[data-la-skin]');
    var form = document.querySelector('form.js-product-form-main');
    if (!host || !form) return;
    createSkin({
      host: host, form: form,
      promoHost: document.querySelector('[data-la-promo]'),
      totalBox: document.querySelector('[data-la-total-box]'),
      basePrice: parseFloat(host.dataset.basePrice || '0') / 100,
      noun: host.dataset.noun || 'Oven',
      productTitle: host.dataset.title || (document.querySelector('h1') || {}).textContent || '',
      getBold: function () { return form.querySelector('.bold_options'); },
      submitSelector: '.js-product-form-main button[name=add]',
      alwaysPromo: true
    });
    var info = document.querySelector('.la-info');
    if (info) info.addEventListener('click', function () {
      var box = document.getElementById('la-pickup-info'); if (!box) return;
      box.hidden = !box.hidden; info.setAttribute('aria-expanded', String(!box.hidden));
    });

    /* QuickSpark financing chip: move it onto the Add to Cart row, right-aligned.
       Skipped on quote-only (dedicated truck) units, where that row is hidden. */
    /* Option D: lift the star rating onto the price row and collapse the empty
       app-block gaps, so the configurator starts higher up the column. */
    var priceBlock = document.querySelector('.product-info__block.product-price');
    function findRating() {
      var found = null;
      document.querySelectorAll('.product-info > .product-info__block').forEach(function (b) {
        if (found || b.classList.contains('product-price')) return;
        if (b.querySelector('[class*="ali-widget-st"], [class*="star-rating"], .jdgm-prev-badge, [class*="review"][class*="badge"]')) found = b;
      });
      return found;
    }
    function collapseEmpties() {
      document.querySelectorAll('.product-info > .product-info__block').forEach(function (b) {
        if (b.classList.contains('la-rating')) return;
        b.classList.toggle('la-zero', b.offsetHeight === 0);
      });
    }
    if (priceBlock) {
      var rTries = 0;
      (function liftRating() {
        var rb = findRating();
        if (rb) {
          if (!priceBlock.contains(rb)) { rb.classList.add('la-rating'); priceBlock.appendChild(rb); }
          collapseEmpties();
          return;
        }
        collapseEmpties();
        if (++rTries < 40) setTimeout(liftRating, 300);   /* the reviews app renders late */
      })();
      setTimeout(collapseEmpties, 2500);
    }

    /* On quote pages the Feedback Promo line reads better after the ask than before it:
       move it below the quote sub-text, just above the testimonial. The skin keeps a
       reference to the element, so relocating it does not affect what renders inside. */
    (function movePromo() {
      var wrap = document.querySelector('.la-buy--quote');
      if (!wrap) return;
      var tries = 0;
      (function place() {
        var promo = document.querySelector('[data-la-promo]');
        var sub = wrap.querySelector('.la-quote__sub');
        if (promo && sub && sub.parentNode) {
          if (promo.previousElementSibling !== sub) sub.parentNode.insertBefore(promo, sub.nextSibling);
          return;
        }
        if (++tries < 40) setTimeout(place, 300);
      })();
    })();

    var buyWrap = document.querySelector('.la-buy');
    var atc = document.querySelector('.product-info__add-to-cart');
    if (atc && buyWrap && !buyWrap.classList.contains('la-buy--quote')) {
      /* QuickSpark recalculates the monthly figure on every quantity change, and re-renders
         its widget back into its own mount point up in the price block — dropping our class
         with it. Placing it once (it also injects late) isn't enough: watch for it and put
         it back whenever it turns up outside the Add to Cart row. Moving it back only
         triggers the "already in place" branch, so this can't loop. */
      var finQueued = false;
      function placeFin() {
        finQueued = false;
        var fin = document.querySelector('.ls-detail-button-cont');
        if (!fin || atc.contains(fin)) return;
        fin.classList.add('la-fin--inline');
        atc.appendChild(fin);
      }
      function queueFin() { if (!finQueued) { finQueued = true; setTimeout(placeFin, 60); } }
      function finOnQty(e) {
        if (e.target && e.target.closest && e.target.closest('.qty-input')) { setTimeout(placeFin, 250); setTimeout(placeFin, 900); }
      }
      placeFin();
      new MutationObserver(queueFin).observe(document.body, { childList: true, subtree: true });
      document.addEventListener('change', finOnQty, true);
      document.addEventListener('click', finOnQty, true);
    }
  }

  /* ---------- cart page: Bold's "Edit Order" lightbox ----------
     Bold injects .bold_lightbox into <body> with the same option markup the
     product page uses, inside form.bold_options_edit_in_cart. We mount the
     skin into that form the moment it appears, with its own total box. */
  function mountLightbox(lb) {
    var form = lb.querySelector('form.bold_options_edit_in_cart');
    if (!form || form.querySelector('[data-la-skin]')) return;
    var set = form.querySelector('.bold_option_set');
    if (!set) return;
    var title = norm((lb.querySelector('.bold_option_product_info_title') || {}).textContent || '');
    var priceTxt = (lb.querySelector('.bold_option_product_info_price') || {}).textContent || '';
    var noun = /booth/i.test(title) ? 'Spray Booth' : 'Oven';
    var prebuilt = /in-stock/i.test(title);
    var basePrice = parsePrice(priceTxt);

    var head = el('div', 'la-lb__head', '' +
      (prebuilt ? '<span class="la-lb__note">&#9889; This unit is already built — its installed upgrades are locked.</span>' : '<span class="la-lb__note">Change any upgrade below; the total updates as you go.</span>'));
    var host = el('div', 'la-skin'); host.setAttribute('data-la-skin', '');
    var promo = el('div', 'la-promo'); promo.setAttribute('data-la-promo', '');
    var total = el('div', 'la-total'); total.setAttribute('data-la-total-box', '');
    var mn = modelName(title);
    total.innerHTML = '<div class="la-total__r"><span>' + esc(mn ? mn + ' Base' : 'Base price') + '</span><span>' + money(basePrice) + '</span></div>' +
      '<div class="la-total__r"><span>Upgrades (<span data-la-count>0</span>)</span><span data-la-extras>+$0.00</span></div>' +
      '<div class="la-total__big"><span>Your ' + noun + '</span><b data-la-total>' + money(basePrice) + '</b></div>';
    set.parentNode.insertBefore(head, set);
    set.parentNode.insertBefore(host, set);
    set.parentNode.insertBefore(promo, set.nextSibling);
    promo.parentNode.insertBefore(total, promo.nextSibling);   /* stays in the scroll area, clear of Bold's sticky footer */
    lb.classList.add('la-lb');

    createSkin({
      host: host, form: form, promoHost: promo, totalBox: total, basePrice: basePrice, noun: noun, wrapEl: form,
      productTitle: title,
      getBold: function () { return form; },
      submitSelector: '.bold_options_lightbox_cart_edit_update_btn'
    });
  }
  function initCart() {
    if (location.pathname.indexOf('/cart') !== 0) return;
    var scan = function () { document.querySelectorAll('.bold_lightbox').forEach(mountLightbox); };
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    scan();
  }

  function init() { initProduct(); initCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
